import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Hub } from '../../../components';
import { CaptionText, H2, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { PurchaseSteps } from '../../Marketplace/Maeketplace.types';
import { useDispatch } from 'react-redux';
import { purchasePackage } from '../../Marketplace/Marketplace.actions';
import {
  CLUB,
  LP,
  USDT,
  formatUSD,
  formatUSDNoDecimals
} from '../../../helpers/helperFunctions';
import { useAppSelector } from '../../../app/hooks';
import { NetworkType } from '../../../types/types';

import voucherImage from '../../../assets/images/backoffice/willyImages/voucherCoins.png';
import { CheckText } from '../../../components/common/CheckText';

interface PaymentMethodProps {
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedPackage: any;
  selectedLicence: any;
  setUsdt: Dispatch<SetStateAction<string>>;
  userDiscountCodeId?: number | null;
}

export const PaymentMethod = ({
  setStep,
  selectedPackage,
  selectedLicence,
  setUsdt,
  userDiscountCodeId
}: PaymentMethodProps) => {
  const { t } = useTranslation('marketplace');
  const [checkbox, setCheckbox] = useState(false);

  if (!selectedPackage?.packageId) return null;

  const showButtonText = () => {
    if (selectedLicence === null && packageId >= 150) {
      return 'Pay with USDT and CLUB balance';
    } else {
      return 'Pay with USDT and CLUB balance';
    }
  };

  const {
    packageId,
    price,
    weeklyCap,
    limitedQuantity,
    tradingBinaryPercentage,
    calculator,
    willyMemeCoins,
    memeBonusActivationPrice,
    isMemeBonusActivated
  } = selectedPackage;

  return (
    <div>
      <P1 bold mb={'20'}>
        SELECTED VOUCHER:
      </P1>

      <Hub
        key={packageId}
        condensed
        image={voucherImage}
        title={`${formatUSDNoDecimals(price)} Will per day`}
        price={memeBonusActivationPrice}
        isMemeBonusActivated={!isMemeBonusActivated}
        packagePrice={price}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        includesSubscription={selectedLicence?.access}
        isDiscount={userDiscountCodeId !== null}
        willyMemeCoins={willyMemeCoins}
        info={
          <>
            {calculator && (
              <Flexed alignEnd end>
                <H2 bold mr='16' alignEnd>
                  {calculator}
                </H2>
                <CaptionText bold right mb='4'>
                  {t('reward')}
                  <br />
                  {t('multiplicator')}
                </CaptionText>
              </Flexed>
            )}
          </>
        }
      />

      <P2 mb={'20'} mt={'40'}>
        Purchasing the selected voucher:
      </P2>
      <P2 mb={'5'}>❌ Will NOT generate any Business Volume Points (BV)</P2>
      <P2 mb={'5'}>
        ❌ Will NOT generate any Bonuses (Team Bonus, Matching Bonus, Direct
        Bonus)
      </P2>
      <P2 mb={'20'}>
        ✅ Will give you the amount of Willy meme coins per day that is stated
        above from the next day of your purchase until February 9 (23:59 UTC),
        2025.
      </P2>

      <CheckText
        checked={checkbox}
        onClick={() => setCheckbox(!checkbox)}
        text={
          'I understand and accept the rules of this purchase that are stated above.'
        }
      />

      {/* MIXED PAYMENT */}
      <Button
        mb={20}
        onClick={() => setStep(PurchaseSteps.PAY_MIXED)}
        disabled={!checkbox}>
        {showButtonText()}
      </Button>
      {/* MIXED PAYMENT */}

      <Button
        negative
        mb={20}
        disabled={!checkbox}
        onClick={() => {
          setStep(PurchaseSteps.PAY_TETHER);
          setUsdt(memeBonusActivationPrice.toString());
        }}>
        {t('pay_with_tether')}
      </Button>
    </div>
  );
};
